export default __webpack_public_path__ + "static/media/ic_simpleswaps.d4a80ef2.svg";